import React from "react";
import { Helmet } from "react-helmet";

const OpenGraphMeta = ({ 
  title, 
  description, 
  image = "https://www.kinetx.co/KinetxLogo.png",
  url,
  type = "website"
}) => {
  return (
    <Helmet>
      {/* Open Graph Meta Tags */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Kinetx Co" />
      
      {/* Twitter Card Meta Tags */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:site" content="@kinetxco" />
    </Helmet>
  );
};

export default OpenGraphMeta;

